import { USER_STORAGE_KEY, getToken } from "../../user/utils/user";

import { getItemFromStorage } from "./helpers";

const axios = require("axios").default;

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

function makeConfig(token) {
  token = token || getToken();
  return token
    ? {
        headers: {
          Authorization: "Token " + token,
        },
      }
    : {};
}

function getRoleClientData(useRoleClient = false) {
  if (!useRoleClient) return null;

  const user = getItemFromStorage(USER_STORAGE_KEY);
  if (!user?.user?.role_clients) return null;

  const pathParts = window.location.pathname.split("/").filter(Boolean);

  for (const part of pathParts) {
    if (!part.includes("-")) continue;

    const [role, client] = part.split("-").map((s) => s?.toLowerCase());
    if (!role || !client) continue;

    const roleClient = user.user.role_clients.find(
      (rc) =>
        rc.role_name.toLowerCase() === role &&
        rc.client_name.toLowerCase() === client,
    );
    if (roleClient) {
      return { role_client: roleClient.id };
    }
  }

  return null;
}

function addRoleClientToQuery(url, useRoleClient = false) {
  if (!useRoleClient) return url;

  const roleClientData = getRoleClientData(useRoleClient);
  if (roleClientData && roleClientData.role_client) {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}role_client=${roleClientData.role_client}`;
  }

  return url;
}

export function post(url, data, token, useRoleClient = true) {
  return axios.post(
    BACKEND_URL + addRoleClientToQuery(url, useRoleClient),
    data,
    makeConfig(token),
  );
}
export function put(url, data, token, useRoleClient = true) {
  return axios.put(
    BACKEND_URL + addRoleClientToQuery(url, useRoleClient),
    data,
    makeConfig(token),
  );
}
export function patch(url, data, token, useRoleClient = true) {
  return axios.patch(
    BACKEND_URL + addRoleClientToQuery(url, useRoleClient),
    data,
    makeConfig(token),
  );
}

export function get(url, token, useRoleClient = true) {
  return axios.get(
    BACKEND_URL + addRoleClientToQuery(url, useRoleClient),
    makeConfig(token),
  );
}

export function unwrapError(e, form) {
  if (e && e.code === "ERR_NETWORK") {
    const r = "No internet connection";
    return form ? { non_field_errors: r } : r;
  } else if (e && e.code === "ERR_BAD_REQUEST" && e.response.status !== 400) {
    return form
      ? e.response.data
      : e.message + "\n\n" + JSON.stringify(e.response.data, null, 2);
  } else {
    let data = e.response.data;
    return form ? data : JSON.stringify(data);
  }
}
